<template>
  <BCard>
    <div class="flex items-center justify-between mb-2">
      <div class="flex gap-2">
        <b-button
          variant="primary"
          size="sm"
          class="mr-1 rounded-lg p-0"
          @click="$router.go(-1)"
        >
          <feather-icon
            size="2x"
            icon="ChevronLeftIcon"
          />
        </b-button>
        <div class="text-black text-2xl font-semibold">
          Detail Order Packing
        </div>
      </div>
      <b-badge
        v-if="isOrderDibatalkan"
        variant="light-secondary"
        class="!rounded-full px-2 py-1"
      >Dibatalkan</b-badge>
    </div>

    <div
      class="flex justify-end space-x-3"
    >
      <BButton
        :variant="isOrderDibatalkan ? 'outline-secondary' : 'outline-primary'"
        :disabled="urlDownloadLabel === '' || isOrderDibatalkan"
        @click="downloadLinkLable(urlDownloadLabel)"
      >
        Download Label
      </BButton>
    </div>

    <div class="flex items-start bg-[#DFF3FF] px-[14px] py-[10px] space-x-3 rounded-lg my-6">
      <img
        src="https://storage.googleapis.com/komerce/assets/svg/info-circle.svg"
        alt="info-circle"
      >
      <span class="text-[#333]">Pastikan pesanan sejalan dengan label pengiriman. Checklist orderan yang sesuai dengan label pengiriman. Jika ada orderan yang tak sesuai atau resi berlebih, langsung hubungi partner untuk pengajuan susulan. Kita selalu siap membantu!</span>
    </div>
    <BTableSimple
      bordered
      responsive
    >
      <BThead>
        <BTr>
          <BTh class="!capitalize">
            Jenis Order
          </BTh>
          <BTh class="!capitalize">
            Produk
          </BTh>
          <BTh class="!capitalize">
            Variasi
          </BTh>
          <BTh class="!capitalize">
            Jumlah Item
          </BTh>
          <BTh class="!capitalize">
            Jumlah Order
          </BTh>
          <BTh class="!capitalize">
            Bahan Packing & Lapis
          </BTh>
          <BTh
            class="!capitalize"
            style="min-width: 150px !important;"
          >
            Sesuai Resi
          </BTh>
        </BTr>
      </BThead>
      <BTbody>
        <BTr
          v-for="(item, index) in items"
          :key="index"
        >
          <!-- Order Number Cell with Rowspan -->
          <BTd
            v-if="item.orderRowspan > 0"
            :rowspan="item.orderRowspan"
            class="align-top"
          >
            {{ item.order_number }}
          </BTd>
          <!-- Product Name -->
          <BTd
            v-if="item.productRowspan > 0"
            :rowspan="item.productRowspan"
            class="align-top"
          >
            {{ item.product_name }}
          </BTd>
          <!-- Product Variant Name -->
          <BTd class="align-top">
            {{ item.product_variant_name }}
          </BTd>
          <!-- Total Item -->
          <BTd
            v-if="item.productRowspan > 0"
            :rowspan="item.productRowspan"
            class="align-top"
          >
            {{ item.total_item }}
          </BTd>
          <!-- Total Order Cell with Rowspan -->
          <BTd
            v-if="item.orderRowspan > 0"
            :rowspan="item.orderRowspan"
            class="align-top"
          >
            {{ item.total_order }}
          </BTd>
          <!-- Packing Material Order -->
          <BTd
            v-if="item.orderRowspan > 0"
            :rowspan="item.orderRowspan"
            class="align-top min-w-[240px]"
          >
            <list-packing-materials :items="item.packings" />
            <b-button
              v-if="!confirmPacking"
              :variant="disabledPackingSetting(item) ? 'outline-secondary' : 'outline-primary'"
              size="sm"
              class="rounded-lg"
              :disabled="disabledPackingSetting(item) || inputLoading[index]"
              @click="handlePackingSetting(item, index)"
            >
              + Tambah Packaging
            </b-button>
          </BTd>
          <!-- Total Order Approved Cell with Rowspan -->
          <BTd
            v-if="item.orderRowspan > 0"
            :rowspan="item.orderRowspan"
            style="width: 150px !important;"
            class="align-top"
          >
            <div
              v-if="!confirmPacking"
              class="position-relative"
            >
              <b-form-input
                type="number"
                min="0"
                step="1"
                class="w-full"
                :value="item.total_order_approved"
                :disabled="isOrderDibatalkan || inputLoading[index]"
                @input="(value) => handleInputChange(value, index)"
              />
              <div
                v-if="inputLoading[index]"
                class="position-absolute"
                style="right: 8px; top: 42%; transform: translateY(-50%);"
              >
                <b-spinner
                  small
                  variant="primary"
                />
              </div>
            </div>
            <span
              v-else
            >{{ item.total_order_approved }}</span>
          </BTd>
        </BTr>
        <BTr
          v-if="loading"
        >
          <BTd
            :colspan="fields.length"
            class="text-center"
          >
            <b-spinner
              class="align-middle mr-6"
              variant="primary"
            />
            <span>Loading...</span>
          </BTd>
        </BTr>
      </BTbody>
    </BTableSimple>
    <div
      v-if="!loading"
      class="my-[24px] text-black [&>div]:mb-[10px] [&>div]:flex [&>div]:items-center sm:[&>div]:justify-end [&>div]:justify-start [&>div]:gap-2 [&>div]:flex-wrap [&_.value]:flex [&_.value]:gap-[4px] [&_.value]:max-w-[260px] [&_.value]:w-full"
    >
      <div>
        <span
          :class="{
            'max-w-[150px] w-full': confirmPacking || isOrderDibatalkan,
            'max-w-[230px] w-full': !confirmPacking && !isOrderDibatalkan,
          }"
        >Total Order</span>
        <span class="value">: <span>{{ totalApprovedSum }}</span></span>
      </div>
      <div v-if="confirmPacking || isOrderDibatalkan">
        <span
          :class="{
            'max-w-[150px] w-full': confirmPacking || isOrderDibatalkan,
            'max-w-[230px] w-full': !confirmPacking && !isOrderDibatalkan,
          }"
        >Total Biaya</span>
        <span class="value">: <span>{{ totalFulfillmentFeeBefore | rupiah }}</span></span>
      </div>
      <div v-if="!confirmPacking && !isOrderDibatalkan">
        <span class="max-w-[230px] w-full">Biaya Fulfillment Existing</span>
        <span class="value">: <span>{{ totalFulfillmentFeeBefore | rupiah }}</span></span>
      </div>
      <div v-if="!confirmPacking && !isOrderDibatalkan">
        <span class="max-w-[230px] w-full">Biaya Fulfillment Terbaru</span>
        <span class="value">: <span>{{ totalFulfillmentFeeAfter | rupiah }}</span></span>
      </div>
      <div v-if="!confirmPacking && !isOrderDibatalkan">
        <span class="max-w-[230px] w-full">Update Biaya</span>
        <span class="value">: <span>{{ disabledConfirm ? '-' : updatedCost }}</span></span>
      </div>
    </div>

    <div v-if="!confirmPacking && !loading">
      <b-button
        :variant="disabledConfirm ? 'secondary' : 'primary'"
        class="mt-6 float-right flex items-center justify-center gap-[8px]"
        :disabled="disabledConfirm || isMutatingConfirm || loadingRecalculate"
        @click="confirm()"
      >
        <b-spinner
          v-if="isMutatingConfirm"
          small
          variant="white"
        />
        Packing Produk
      </b-button>
    </div>

    <ModalPackagingSettings
      ref="modalPackagingSettings"
      :fetcher="fetcher"
      @on-save="handleSavePacking"
    />

    <ModalSuccessPacking
      ref="modalSuccessPackingNonKomship"
      @on-confirm="handleConfirm"
    />

    <ModalFailedPacking
      ref="modalFailedPackingNonKomship"
    />
  </BCard>
</template>

<script>
import filters from '@/libs/filters'
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import { newAxiosIns } from '@/libs/axios'
import { IDR } from '@/libs/currency'
import { toastError } from '@/libs/toastification'
import ListPackingMaterials from './ListPackingMaterials.vue'
import ModalPackagingSettings from './ModalPackagingSettings.vue'
import ModalSuccessPacking from './ModalSuccessPacking.vue'
import ModalFailedPacking from './ModalFailedPacking.vue'

export default {
  components: {
    ListPackingMaterials,
    ModalPackagingSettings,
    ModalSuccessPacking,
    ModalFailedPacking,
  },
  filters: { rupiah: filters.rupiah },
  data() {
    return {
      loading: false,
      confirmPacking: true,
      items: [],
      orderStatus: '',
      urlDownloadLabel: '',
      fields: [
        { key: 'order_number', label: 'Jenis Order', thClass: '!capitalize' },
        { key: 'product_name', label: 'Produk', thClass: '!capitalize' },
        { key: 'product_variant_name', label: 'Variasi', thClass: '!capitalize' },
        { key: 'total_item', label: 'Jumlah Item', thClass: '!capitalize' },
        { key: 'packings', label: 'Bahan Packing & Lapis', thClass: '!capitalize' },
        { key: 'total_order', label: 'Jumlah Order', thClass: '!capitalize' },
        { key: 'total_order_approved', label: 'Sesuai Resi', thClass: '!capitalize' },
      ],
      fetcher: undefined,
      cachedOrderSummary: undefined,
      selectedPackings: {},
      approvedOrder: {},
      fulfillmentFeeBefore: 0,
      fulfillmentFeeAfter: {},
      isMutatingConfirm: false,
      newGrandFulfillmentFee: 0,
      inputLoading: {},
      loadingRecalculate: false,
      confirmedGrandTotalOrder: 0,
      debouncedRecalculate: null,
    }
  },
  computed: {
    isOrderDibatalkan() {
      return this.orderStatus === 'Dibatalkan'
    },
    totalApprovedSum() {
      if (this.disabledConfirm && !this.confirmPacking) {
        return '-'
      }

      if (this.confirmPacking || this.isOrderDibatalkan) {
        return this.confirmedGrandTotalOrder
      }

      const sum = Object.values(this.approvedOrder).reduce((acc, curr) => acc + curr || 0, 0)

      return sum
    },
    totalFulfillmentFeeBefore() {
      if (this.disabledConfirm && !this.confirmPacking) {
        return '-'
      }

      return this.fulfillmentFeeBefore
    },
    totalFulfillmentFeeAfter() {
      if (this.disabledConfirm) {
        return '-'
      }

      return this.newGrandFulfillmentFee
    },
    updatedCost() {
      if (this.disabledConfirm) {
        return '-'
      }

      const cost = this.newGrandFulfillmentFee ? this.newGrandFulfillmentFee - this.fulfillmentFeeBefore : 0

      return cost < 0 ? `${IDR(cost)} (refund ke partner)` : IDR(cost)
    },
    payload() {
      const orderSet = new Set()
      const payloadArray = []

      this.items.forEach(order => {
        if (!orderSet.has(order.outbound_detail_id)) {
          orderSet.add(order.outbound_detail_id)
          payloadArray.push({
            outbound_detail_id: order.outbound_detail_id,
            total_valid_order: order.total_order_approved,
          })
        }
      })

      return {
        grand_fulfillment_fee: this.totalFulfillmentFee,
        grand_total_order: this.totalApprovedSum,
        payload: payloadArray,
      }
    },
    disabledConfirm() {
      if (this.isOrderDibatalkan) {
        return true
      }

      if (!this.cachedOrderSummary) {
        return true
      }

      const isOrderSameAsApproved = this.cachedOrderSummary.some((item, index) => {
        if (!this.approvedOrder[index + 1]) {
          return false
        }

        return this.approvedOrder[index + 1] <= item.total_order
      })

      return !isOrderSameAsApproved
    },
  },
  created() {
    this.getDetailOrder()
    this.debouncedRecalculate = _.debounce((index, lastApprovedOrder) => {
      const currentItem = this.items[index]
      const numericValue = currentItem.total_order_approved
      const orderNumber = currentItem.order_number
      const totalOrder = currentItem.total_order || 0

      if (numericValue > totalOrder || !numericValue) return

      this.loadingRecalculate = true
      this.$set(this.inputLoading, index, true)
      this.updateTotalOrderApproved(currentItem, numericValue, index, lastApprovedOrder)
      this.$set(this.approvedOrder, orderNumber, numericValue)
    }, 500)
  },
  mounted() {
    this.initializeFetcher()
    this.fetcher.fetchData({ reset: true, options: { search: '' } })
  },
  methods: {
    /*
     * Debounce the recalculate function
     * @param index {Number} - The index of the item
     * @returns {void}
     */
    debouncedUpdate(index, lastApprovedOrder) {
      this.debouncedRecalculate(index, lastApprovedOrder)
    },
    /**
     * Check if the packing setting trigger button is must be disabled
     */
    disabledPackingSetting(item) {
      return !item.total_order_approved || this.disabledConfirm || item.total_order_approved > item.total_order
    },
    /**
     * Initialize fetcher for fetching packing materials
     */
    initializeFetcher() {
      const fnFetch = ({
        offset, limit, search,
      }) => this.$http_new.get('/komship/api/v1/packing-materials', {
        params: {
          offset,
          limit,
          search,
        },
      }).then(res => {
        const { data } = res.data
        return {
          data,
        }
      }).catch(() => {
        toastError('Gagal mengambil data bahan packing, silahkan coba lagi')
        return {
          data: [],
        }
      })

      this.fetcher = createPaginatedFetcher(fnFetch, 0, 50)
    },
    async getDetailOrder() {
      this.loading = true
      await newAxiosIns.get(`/kompack/api/v1/mitra/outbounds/${this.$route.params.id}/detail`)
        .then(res => {
          this.loading = false

          const { data } = res.data
          let grandTotalOrder = 0
          this.fulfillmentFeeBefore = data.grand_fulfillment_fee
          this.orderStatus = data.status

          this.confirmPacking = data.is_confirmed
          this.urlDownloadLabel = data.label_url

          const result = []
          const orderCount = {}
          const productCount = {}

          this.cachedOrderSummary = data.order_summary

          data.order_summary.forEach((order, index) => {
            grandTotalOrder += order?.total_order_approved || 0
            order.products.forEach((product, index2) => {
              const currentPackings = order.packings?.map(packing => ({
                id: packing.option_id ?? packing.id,
                name: packing.name,
                layer: packing.layer,
              }))
              if (product.is_bundling && product.product_bundles.length > 0) {
                product.product_bundles.forEach(bundle => {
                  const orderNumber = index + 1
                  const rawProductId = product.product_id
                  const productId = `${index2}_${product.product_id}`

                  if (!orderCount[orderNumber]) {
                    orderCount[orderNumber] = 0
                  }
                  orderCount[orderNumber] += 1

                  if (!productCount[orderNumber]) {
                    productCount[orderNumber] = {}
                  }
                  if (!productCount[orderNumber][productId]) {
                    productCount[orderNumber][productId] = 0
                  }
                  productCount[orderNumber][productId] += 1

                  result.push({
                    order_number: orderNumber,
                    outbound_detail_id: order.outbound_detail_id,
                    total_order: order.total_order,
                    total_order_approved: order.total_order_approved,
                    fulfillment_fee_per_order: order.fulfillment_fee_per_order,
                    product_id: productId,
                    raw_product_id: rawProductId,
                    bundle_id: bundle.product_id,
                    product_variant_id: bundle.product_variant_id,
                    product_name: product.product_name,
                    product_variant_name: bundle.product_variant_name || bundle.product_name,
                    total_item: product.total_item,
                    is_bundling: product.is_bundling,
                    product_fulfillment: product.product_fulfillment,
                    packings: currentPackings,
                  })
                })
              } else {
                const orderNumber = index + 1
                const productId = `${index2}_${product.product_id}`

                if (!orderCount[orderNumber]) {
                  orderCount[orderNumber] = 0
                }
                orderCount[orderNumber] += 1

                if (!productCount[orderNumber]) {
                  productCount[orderNumber] = {}
                }
                if (!productCount[orderNumber][productId]) {
                  productCount[orderNumber][productId] = 0
                }
                productCount[orderNumber][productId] += 1

                result.push({
                  order_number: orderNumber,
                  outbound_detail_id: order.outbound_detail_id,
                  total_order: order.total_order,
                  total_order_approved: order.total_order_approved,
                  fulfillment_fee_per_order: order.fulfillment_fee_per_order,
                  product_id: productId,
                  bundle_id: null,
                  product_variant_id: product.product_variant_id,
                  product_name: product.product_name,
                  product_variant_name: product.product_variant_name || '-',
                  total_item: product.total_item,
                  is_bundling: product.is_bundling,
                  product_fulfillment: product.product_fulfillment,
                  packings: currentPackings,
                })
              }
            })
          })

          this.confirmedGrandTotalOrder = grandTotalOrder

          this.items = result?.map((item, index, array) => {
            const orderNumber = item.order_number
            const productId = item.product_id

            let orderRowspan = 0
            let productRowspan = 0

            if (index === 0 || orderNumber !== array[index - 1].order_number) {
              orderRowspan = orderCount[orderNumber]
            }
            if (
              index === 0
        || orderNumber !== array[index - 1].order_number
        || productId !== array[index - 1].product_id
            ) {
              productRowspan = productCount[orderNumber][productId]
            }

            return {
              ...item,
              orderRowspan,
              productRowspan,
            }
          })
        }).catch(err => {
          toastError('Gagal mengambil data order, silahkan coba lagi')
        })
    },
    /**
     * Update the total order approved with recalculation because of order total changed
     */
    async updateTotalOrderApproved(currentItem, numericValue, index, lastApprovedOrder) {
      const orderNumber = currentItem.order_number
      const currentIndex = index || 0

      try {
        const currentProduct = this.cachedOrderSummary[orderNumber - 1]

        const products = currentProduct.products?.map(product => ({
          product_id: product.product_id,
          total_item: product.total_item,
          is_product_bonus: product.is_product_bonus,
          is_bundling: product.is_bundling,
          bundle_components: product.product_bundles?.map(bundle => ({
            product_id: bundle.product_id,
            qty: bundle.qty || 1,
            is_product_bonus: bundle.is_product_bonus,
          })),
        }))
        const payload = {
          total_order: numericValue,
          packings: currentItem.packings?.map(packing => ({
            id: packing.id,
            total_layer: packing.layer,
          })),
          products,
        }

        const data = await this.$refs.modalPackagingSettings.recalculateFulfillment(payload)
        this.fulfillmentFeeAfter[orderNumber] = data.fulfillment_cost
        this.approvedOrder[orderNumber] = numericValue

        this.newGrandFulfillmentFee = Object.values(this.fulfillmentFeeAfter).reduce((acc, curr) => acc + curr, 0)

        this.$set(this.items, currentIndex, {
          ...currentItem,
          total_order_approved: numericValue,
          fulfillment_fee: data.fulfillment_cost,
        })
      } catch (error) {
        this.$set(this.approvedOrder, orderNumber, lastApprovedOrder)
        this.$set(this.items, currentIndex, {
          ...currentItem,
          total_order_approved: lastApprovedOrder,
        })
        toastError('Gagal menghitung biaya fulfillment, silahkan coba lagi')
      } finally {
        this.$set(this.inputLoading, currentIndex, false)
      }
      this.loadingRecalculate = false
    },
    handleInputChange(value, index) {
      const numericValue = parseInt(value, 10) || 0
      const currentItem = this.items[index]
      const lastApprovedOrder = currentItem.total_order_approved
      const orderNumber = currentItem.order_number

      // Update UI immediately (reaktif)
      this.$set(this.items, index, { ...currentItem, total_order_approved: numericValue })

      if (!numericValue || numericValue > currentItem.total_order) {
        this.$set(this.approvedOrder, orderNumber, 0)
        this.$set(this.fulfillmentFeeAfter, orderNumber, 0)
        this.newGrandFulfillmentFee = Object.values(this.fulfillmentFeeAfter).reduce((acc, curr) => acc + curr, 0)
        return
      }

      // Debounce API call for recalculate
      this.debouncedUpdate(index, lastApprovedOrder)
    },
    /**
     * Handle confirming process of the partner order
     * @returns {void}
     */
    async confirm() {
      this.isMutatingConfirm = true
      const payload = {
        grand_fulfillment_fee: this.newGrandFulfillmentFee || this.totalFulfillmentFeeBefore,
        grand_total_order: this.totalApprovedSum,
        payload: this.cachedOrderSummary.map((item, index) => ({
          outbound_detail_id: item.outbound_detail_id,
          total_valid_order: this.approvedOrder[index + 1],
          packings: this.selectedPackings[index + 1] || (item.packings && item.packings.map(packing => ({
            id: packing.option_id || packing.id,
            name: packing.name,
            layer: packing.layer,
          }))) || undefined,
          fulfillment_fee: this.fulfillmentFeeAfter[index + 1] || (item.fulfillment_fee_per_order * this.approvedOrder[index + 1]),
        })),
      }

      try {
        await this.$http_new.put(`/kompack/api/v1/mitra/outbounds/${this.$route.params.id}/confirm`, payload)
        this.$refs.modalSuccessPackingNonKomship.show()
      } catch (error) {
        const message = error.response.data?.meta?.message
        if (message?.toLowerCase().includes('insufficient balance')) {
          this.$refs.modalFailedPackingNonKomship.show()

          return
        }
        toastError('Gagal mengkonfirmasi packing, silahkan coba lagi')
      } finally {
        this.isMutatingConfirm = false
      }
    },
    async downloadLinkLable(url) {
      await newAxiosIns.put(`/kompack/api/v1/mitra/outbounds/${this.$route.params.id}/status-print`, { is_print: true }).then(() => {
        window.open(url, '_blank')
      })
    },
    /**
     * Handle when user want to update the order packing material
     * @param item {Object} - The item data from the cached order summary
     * @param index {Number} - The index of the item
     * @returns {void}
     */
    handlePackingSetting(item, index) {
      const data = this.cachedOrderSummary[item.order_number - 1]
      this.$refs.modalPackagingSettings.show({
        data,
        totalOrder: item.total_order_approved,
        position: index,
        orderNumber: item.order_number,
        packings: item.packings,
      })
    },
    /**
     * Handle when update order packing material process is done.
     * - Update the grand fulfillment fee
     * - Update the items data for displaying on the table
     * @param message {Object} - The message object containing the position, order number, and data
     * @returns {void}
     */
    handleSavePacking(message) {
      const { position, order_number, data } = message
      this.fulfillmentFeeAfter[order_number] = data.fulfillment_cost
      this.newGrandFulfillmentFee = Object.values(this.fulfillmentFeeAfter).reduce((acc, curr) => acc + curr, 0)
      this.$set(this.items, position, {
        ...this.items[position],
        fulfillment_fee: data.fulfillment_cost,
        packings: data.packings,
      })
      this.selectedPackings[order_number] = data.packings
    },
    /**
     * Handle when confirm packing process is done. both success and failed modal.
     * @returns {void}
     */
    handleConfirm() {
      this.getDetailOrder()
      this.fulfillmentFeeAfter = {}
    },
  },
}
</script>

<style lang="scss">
@import '@/@core/scss/vue/libs/vue-select.scss';
</style>
